import React from "react";
import { BrowserRouter } from "react-router-dom";
import { FrameContextProvider } from "./contexts/FrameContext";
import Router from "./routes/Router";

function App() {
  return (
    <BrowserRouter>
      <FrameContextProvider>
        <Router />
      </FrameContextProvider>
    </BrowserRouter>
  );
}

export default App;
